import { ADD_PUNTO } from "./types";

export const agregarPuntos = (puntos) => {
  return { type: ADD_PUNTO, payload: puntos };
};
